import produce from "immer";

import {CHANGE_LANGUAGE} from "src/actions/multiLanguageActions";

import {LOCALES, languageByCode} from "src/i18n/locales";

const retrieveLocalLang = () => {
  try {
    const curLangFromLocal = localStorage.getItem("languageInUse");
    if (!curLangFromLocal) {
      throw new Error("LocalLanguage not found");
    }
    return JSON.parse(curLangFromLocal);
  } catch (error) {
    localStorage.setItem("languageInUse", JSON.stringify(LOCALES.VIETNAMESE));
    return LOCALES.VIETNAMESE;
  }
};

const initialState = {
  currentLanguage: retrieveLocalLang()
};

const multiLanguageReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LANGUAGE: {
      const {languageCode} = action.payload;

      return produce(state, (draft) => {
        const language = languageByCode(languageCode);
        draft.currentLanguage = LOCALES[language];
      });
    }

    default: {
      return state;
    }
  }
};

export default multiLanguageReducer;
